var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_15)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.800018C4.91903 0.800018 0.800049 4.919 0.800049 10C0.800049 15.081 4.91903 19.2 10 19.2C15.0811 19.2 19.2001 15.081 19.2001 10C19.2001 4.919 15.0811 0.800018 10 0.800018ZM2.00005 10C2.00005 5.58174 5.58177 2.00002 10 2.00002C14.4183 2.00002 18 5.58174 18 10C18 14.4183 14.4183 18 10 18C5.58177 18 2.00005 14.4183 2.00005 10ZM10.6 4.60001C10.6 4.26864 10.3314 4.00001 10 4.00001C9.66863 4.00001 9.4 4.26864 9.4 4.60001V9.99999C9.4 10.2273 9.5284 10.435 9.73167 10.5366L13.7317 12.5366C14.0281 12.6848 14.3885 12.5647 14.5367 12.2683C14.6848 11.9719 14.5647 11.6115 14.2683 11.4633L10.6 9.62917V4.60001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.f809cc6104d2a8557fcf3695dc108a3a.svg";
export { ForwardRef as ReactComponent };